import React, { Component } from "react";
import { DndProvider } from "react-dnd-cjs";
import HTML5Backend from "react-dnd-html5-backend-cjs";
import classNames from "classnames";
import PropTypes from "prop-types";

import FileDropTarget from "./FileDropTarget";

import styles from "./FileDropZone.css";

export default class FileDropZone extends Component {
  constructor(props) {
    super(props);
    this.handleFileDrop = this._handleFileDrop.bind(this);
    this.handleFileInput = this._handleFileInput.bind(this);
  }

  _handleFileDrop(item, monitor) {
    if (monitor) {
      this.props.onUpload(monitor.getItem().files[0]);
    }
  }

  _handleFileInput(event) {
    event.preventDefault();
    this.props.onUpload(event.target.files[0]);
  }

  render() {
    return (
      <div className={classNames(styles.root, this.props.className)}>
        <DndProvider backend={HTML5Backend}>
          <FileDropTarget
            onDrop={this.handleFileDrop}
            onInput={this.handleFileInput}
            helpText={this.props.helpText}
          />
        </DndProvider>
      </div>
    );
  }
}

FileDropZone.propTypes = {
  className: PropTypes.string,
  onUpload: PropTypes.func.isRequired,
  helpText: PropTypes.string,
};
